/**
 * @file The "a lazy screen is downloading" placeholder.
 *
 * Renders nothing for the first 150 ms so a cached or fast chunk never flashes a spinner, then the
 * app's usual loading panel.
 */
import { useEffect, useState } from "react";
import { CenteredPanel, Spinner } from "./ui";

const DELAY_MS = 150;

export function RoutePending() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), DELAY_MS);
    return () => clearTimeout(timer);
  }, []);
  if (!visible) return null;
  return (
    <CenteredPanel>
      <Spinner />
      Loading&hellip;
    </CenteredPanel>
  );
}
